import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { ConfigProvider, App as AntdApp } from 'antd';
import { AuthProvider } from './providers/AuthProvider';
import { AppLayout } from './layouts/AppLayout';
import { Login } from './pages/Authentication/Login';
import { Register } from './pages/Authentication/Register';
import { ForgotPassword } from './pages/Authentication/ForgotPassword';
import { ResetPassword } from './pages/Authentication/ResetPassword';
import { ResendSignUpToken } from './pages/Authentication/ResendSignUpToken';
import { VerifySignUp } from './pages/Authentication/VerifySignUp';
import { Dashboard } from './pages/Dashboard';
import { PageNotFound } from './pages/PageNotFound';
import { PrivateRoute } from './components/PrivateRoute';
import { ProfileViewPage } from './pages/User/Profile/View';
import { MyPlansList } from './pages/MyPlans/List';
import { AdminPage } from './pages/Admin/List';
import UserLayout from './pages/User/Layout';
import ListDirectories from './pages/Admin/Directories/List';
import DirectoryCreatePage from './pages/Admin/Directories/Create';
import DirectoryEditPage from './pages/Admin/Directories/Edit';
import DirectoryView from './pages/Admin/Directories/View';
import ListContractors from './pages/Admin/Contractors/List';
import ContractorCreate from './pages/Admin/Contractors/Create';
import ContractorEdit from './pages/Admin/Contractors/Edit';
import ContractorView from './pages/Admin/Contractors/View';
import ListUsers from './pages/Admin/Users/List';
import UserCreate from './pages/Admin/Users/Create';
import UserEdit from './pages/Admin/Users/Edit';
import UserView from './pages/Admin/Users/View';
import AdminLayout from './pages/Admin/Layout';
import ListPlans from './pages/Admin/Plans/List';
import { PlanView } from './pages/Plans/View';
import { AdminPlanView } from './pages/Admin/Plans/View';
import { PlanEdit } from './pages/Admin/Plans/Edit';
import { PlanCreate } from './pages/Admin/Plans/Create';
import ProductsOfConfigurators from './pages/Admin/ProductsOfConfigurators';
import MapList from './pages/Admin/MapList';
import MapGuestList from './pages/Map/MapGuestList';
import CreativeStudio from './pages/Admin/Plans/CreativeStudio';
import ListSiteVisit from './pages/Admin/Site-Visit/List';
import SiteVisitPage from './pages/Site-Visit/Create';
import { ToolListPage } from './pages/Tools/List';
import SiteVisitList from './pages/Site-Visit/List';
import PageSiteVisitView from './pages/Site-Visit/View';
import SiteVisitEditPage from './pages/Site-Visit/Edit';

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Layout: {
            headerBg: '#ffffff',
            headerColor: '#000000',
          },
          Card: {},
          Button: {
            // colorPrimary: '#ee8865',
            // colorPrimaryHover: '#f2a183',
            // defaultHoverColor: '#f2a183',
            // defaultHoverBorderColor: '#f2a183',
            // colorPrimaryActive: '#f2a183',
            // colorPrimaryText: '#ffffff',
            // defaultActiveBorderColor: '#ee8865',
            // defaultActiveColor: '#f2a183',
            // groupBorderColor: '#f2a183',
            // textTextActiveColor: '#ffffff',
            // textTextColor: '#ffffff',
            // textTextHoverColor: '#ffffff',
          },
          Carousel: {
            dotWidth: 8,
            dotHeight: 8,
            dotActiveWidth: 12,
          },
        },
      }}>
      <AntdApp>
        <AuthProvider>
          <Router>
            <AppLayout>
              <Routes>
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password/:token" element={<ResetPassword />} />
                <Route path="resend-signup-token" element={<ResendSignUpToken />} />
                <Route path="verify-sign-up/:token" element={<VerifySignUp />} />

                <Route path="user" element={<UserLayout />}>
                  <Route index element={<ProfileViewPage />} />
                  <Route path="profile" element={<ProfileViewPage />} />
                </Route>

                <Route path="plans" element={<MapGuestList />} />

                <Route path="admin" element={<AdminLayout />}>
                  <Route index element={<AdminPage />} />
                  <Route path="directories" element={<ListDirectories />} />
                  <Route path="directory/edit/:id" element={<DirectoryEditPage />} />
                  <Route path="directory/new" element={<DirectoryCreatePage />} />
                  <Route path="directory/:id" element={<DirectoryView />} />

                  <Route path="contractors" element={<ListContractors />} />
                  <Route path="contractor/new" element={<ContractorCreate />} />
                  <Route path="contractor/edit/:id" element={<ContractorEdit />} />
                  <Route path="contractor/:id" element={<ContractorView />} />

                  <Route path="users" element={<ListUsers />} />
                  <Route path="user/new" element={<UserCreate />} />
                  <Route path="user/edit/:id" element={<UserEdit />} />
                  <Route path="user/:id" element={<UserView />} />

                  <Route path="plans" element={<ListPlans />} />
                  <Route path="plan/view/:id" element={<AdminPlanView />} />
                  <Route path="plan/:id" element={<AdminPlanView />} />
                  <Route path="plan/edit/:id" element={<PlanEdit />} />
                  <Route path="plan/new" element={<PlanCreate />} />
                  <Route path="plan/creative-studio/:id" element={<CreativeStudio />} />
                  <Route path="products-of-configurators" element={<ProductsOfConfigurators />} />
                  <Route path="plans-lists" element={<MapList />} />

                  <Route path="site-visits" element={<ListSiteVisit />} />
                </Route>

                <Route path="tools" element={<ToolListPage />} />
                <Route path="site-visit/new" element={<SiteVisitPage />} />
                <Route path="site-visit/list" element={<SiteVisitList />} />
                <Route path="site-visit/:id" element={<PageSiteVisitView />} />
                <Route path="site-visit/edit/:id" element={<SiteVisitEditPage />} />
                <Route path="/plan/:id/:mapId?" element={<PlanView />} />

                <Route
                  path="/my-plans"
                  element={
                    <PrivateRoute>
                      <MyPlansList />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </AppLayout>
          </Router>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

export default App;
